/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Booking-level discriminator matching the slot type: SINGLE seat, GROUP seats, or RANGE (a client-picked sub-window of an open range; always one person).
 */
export enum UpdateProfessionalBookingBodyBookingType {
  SINGLE = 'SINGLE',
  GROUP = 'GROUP',
  RANGE = 'RANGE'
}
